import React from 'react';
import { memo } from 'react';

/**
 * MaintenanceOilChange Icon - Used in Maintenance reminder page
 */
const MaintenanceOilChangeIcon = ({ size = 48 }: { size?: number }): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48" fill="none">
      <path d="M15 6H11V16H15V6Z" fill="#6E7E91" />
      <path
        d="M3 6H23C23.2652 6 23.5196 5.89464 23.7071 5.70711C23.8946 5.51957 24 5.26522 24 5C24 4.73478 23.8946 4.48043 23.7071 4.29289C23.5196 4.10536 23.2652 4 23 4H3C2.73478 4 2.48043 4.10536 2.29289 4.29289C2.10536 4.48043 2 4.73478 2 5C2 5.26522 2.10536 5.51957 2.29289 5.70711C2.48043 5.89464 2.73478 6 3 6Z"
        fill="#D9E0E9"
      />
      <path
        d="M46.577 14.183C46.4465 14.0906 46.2958 14.0309 46.1375 14.0088C45.9791 13.9867 45.8178 14.0029 45.667 14.056L29.423 19.789L24.848 12.47C24.7581 12.3262 24.6331 12.2076 24.4848 12.1254C24.3364 12.0431 24.1696 12 24 12H5C3.93913 12 2.92172 12.4214 2.17157 13.1716C1.42143 13.9217 1 14.9391 1 16V31C1 32.0609 1.42143 33.0783 2.17157 33.8284C2.92172 34.5786 3.93913 35 5 35H28C28.2341 35.0004 28.461 34.9187 28.641 34.769L46.641 19.769C46.7536 19.675 46.8441 19.5574 46.9061 19.4245C46.9682 19.2916 47.0002 19.1467 47 19V15C47 14.8399 46.9616 14.6821 46.888 14.54C46.8144 14.3978 46.7078 14.2754 46.577 14.183Z"
        fill="#FF3975"
      />
      <path
        d="M41.293 32.293C41.117 32.468 37 36.636 37 41C37 42.3261 37.5268 43.5979 38.4645 44.5356C39.4021 45.4732 40.6739 46 42 46C43.3261 46 44.5979 45.4732 45.5355 44.5356C46.4732 43.5979 47 42.3261 47 41C47 36.636 42.883 32.468 42.707 32.293C42.5195 32.1056 42.2652 32.0002 42 32.0002C41.7348 32.0002 41.4805 32.1056 41.293 32.293Z"
        fill="#6E7E91"
      />
    </svg>
  );
};
export default memo(MaintenanceOilChangeIcon);
